import React, { useState, useEffect } from 'react'
import {
  Div, LoadingIcon, Icon,
} from 'konsys-ui'
import { Select } from 'antd'
import { Query } from 'react-apollo'
import InfiniteScroll from 'react-infinite-scroller'
import history from '../../../history'
import { WidthContainer } from '../../../components/container/styled'
import Banner from '../../../images/packaging-catalog/banner.jpg'
import { theme } from '../../../styles/_variables'
import {
  ImageWrapper, ImageLabel, ImageLabelOther, ImgBg,
  DivPackage, DivSearch, InputSearch, DivToolbar, ButtonSearch,
  ButtonToolbar, Label, DivButtonToolbar, CustomSelect, PackageContainer,
  TagDivActive, Modal,
} from './styled'
import PATH from '../../../constants/path'
import { SHOW_PACKAGE, SHOW_TAG } from '../../../constants/graph/query'
import Container from '../../../components/container'
import TagFilter from '../components/tag-filter'


const PackagingCatalogContainer = () => {
  const limit = 12
  const [textSearch, setTextSearch] = useState('')
  const [settingVisible, setSettingVisible] = useState(false)
  const [settingFilter, setSettingFilter] = useState(false)
  const [tmpFilterBy, setTmpFilterBy] = useState([])
  const [filterBy, setFilterBy] = useState([])
  const [tmpSortBy, setTmpSortBy] = useState({
    order: 'ordering',
    sort: 'ASC',
  })
  const [sortBy, setSortBy] = useState({
    order: 'ordering',
    sort: 'ASC',
  })

  const handleSort = (value) => {
    const result = value.split('_')
    setTmpSortBy({
      order: result[0],
      sort: result[1],
    })
    // setSettingVisible(false)
  }

  const handleCloseSort = () => {
    setSortBy({
      order: tmpSortBy.order,
      sort: tmpSortBy.sort,
    })
    setSettingVisible(false)
  }

  const handleOnChangeFilter = (index, isActive) => {
    const tmp = [...tmpFilterBy]
    tmp[index].active = isActive
    setTmpFilterBy(tmp)
  }

  const handleOnClearFilter = () => {
    let tmp = [...tmpFilterBy]
    tmp = tmp.map(item => ({
      ...item,
      active: false,
    }))
    setTmpFilterBy(tmp)
  }

  const handleOnCloseFilter = () => {
    setFilterBy(JSON.parse(JSON.stringify(tmpFilterBy)))
    setSettingFilter(false)
  }

  useEffect(() => {
    localStorage.removeItem('package')
  }, [localStorage.getItem('package')])

  return (
    <Container header={{
      type: 'title',
      img: Banner,
      title: 'รายการบรรจุภัณฑ์',
      color: theme.color.offWhite,
    }}>
      <WidthContainer>
        <DivToolbar>
          <Search value={textSearch} onSummit={value => setTextSearch(value)}/>
          <DivButtonToolbar>
            <ButtonToolbar
              text='ตัวเลือก'
              icon='fas fa-sliders-h'
              inverse
              onClick={() => setSettingFilter(true)}
            />
            <ButtonToolbar
              text='การจัดเรียง'
              icon='fas fa-sort-amount-down'
              inverse
              onClick={() => setSettingVisible(true)}
            />
          </DivButtonToolbar>
        </DivToolbar>
        <Div style={{ padding: '8px 0px' }}>
          {
          filterBy.reduce((result, item) => {
            if (item.active) {
              result.push(<TagDivActive
                text={item.title}
                icon='fa fa-tag fa-rotate-90'
                inverse
                onClick={async () => {
                  const tmp = [...tmpFilterBy]
                  tmp[item.key].active = false
                  setTmpFilterBy(tmp)
                  setFilterBy(JSON.parse(JSON.stringify(tmp)))
                }}
              />)
            }
            return result
          }, [])
          }
        </Div>
      </WidthContainer>
      <Query
        query={SHOW_PACKAGE}
        fetchPolicy='cached-and-network'
        variables={{
          limit,
          offset: 0,
          name: textSearch,
          order: sortBy.order || 'ordering',
          sort: sortBy.sort || 'ASC',
          status: 'active',
          tag: filterBy.reduce((result, item) => {
            if (item.active) result.push(item.value)
            return result
          }, []),
        }}
      >
        {
          ({ loading, data, fetchMore }) => {
            if (loading) return <Div margin='24px 0' textAlign='center'><LoadingIcon color={theme.color.grey} /></Div>
            if (!data.showPackaging.success) return <p>error something</p>
            const packagingData = data.showPackaging.packaging.filter(item => item.ordering !== -1)
            const packagingOther = data.showPackaging.packaging.filter(item => item.ordering === -1)

            return (
              <WidthContainer>
                <div>
                  <InfiniteScroll
                    initialLoad={false}
                    loadMore={() => {
                      fetchMore({
                        variables: {
                          limit,
                          offset: data.showPackaging.packaging.length,
                          name: textSearch,
                          status: 'active',
                          order: sortBy.order || 'ordering',
                          sort: sortBy.sort || 'DESC',
                          tag: filterBy.reduce((result, item) => {
                            if (item.active) result.push(item.value)
                            return result
                          }, []),
                        },
                        updateQuery: (prev, { fetchMoreResult }) => {
                          if (!fetchMoreResult.showPackaging.success) return prev
                          return Object.assign({}, prev, {
                            showPackaging: {
                              ...prev.showPackaging,
                              packaging: [...prev.showPackaging.packaging, ...fetchMoreResult.showPackaging.packaging],
                            },
                          })
                        },
                      })
                    }}
                    threshold={200}
                    pageStart={0}
                    hasMore={data.showPackaging.packaging.length < data.showPackaging.count}
                    loader={() => (<Div margin='0 0 24px'><LoadingIcon fullWidth center /></Div>)}
                  >
                    <PackageContainer>
                      {
                        packagingData.map(v => (
                          <Package onClick={() => history.push(`${PATH.packagingDetail}/${v.packageId}`)} key={v.packageId} data={v} />
                        ))
                      }
                      {
                        packagingOther && packagingOther.length > 0 && <Package onClick={() => history.push(PATH.request)} data={packagingOther[0]} key={packagingOther[0].packageId}/>
                      }
                    </PackageContainer>
                  </InfiniteScroll>
                </div>
              </WidthContainer>
            )
          }
        }
      </Query>
      <Modal
        title={
          <Label color={theme.color.textColor} style={{ fontWeight: theme.fonts.style.regular }}>
            <Icon icon='fas fa-sliders-h' margin='0px 8px 0px 0px' color={theme.color.primaryColor} style={{ fontWeight: theme.fonts.style.regular }} />
            เลือกตัวเลือกการค้นหาที่ต้องการ
          </Label>
        }
        visible={settingFilter}
        onCancel={handleOnCloseFilter}
        footer={null}
        closable={false}
        centered={true}
      >
        <Div position='absolute' top='16px' right='16px' cursor='pointer' onClick={handleOnCloseFilter}>
          <Icon fontSize={theme.fonts.size.extraNormal} color={theme.color.grey} icon='far fa-times' />
        </Div>
        <Query
          query={SHOW_TAG}
          fetchPolicy={'network-only'}
          variables={{
            limit: 1000,
            offset: 0,
            order: 'createdAt',
            sort: 'ASC',
          }}
          onCompleted={(data) => {
            setTmpFilterBy(data.listTag.tag.map((item, index) => ({
              key: index,
              value: item.tagId,
              title: item.name,
              active: false,
            })))
          }}
        >
        {
          ({ loading, data }) => {
            if (loading) return <Div margin='24px 0' textAlign='center'><LoadingIcon color={theme.color.grey} /></Div>
            if (!data.listTag.success) return <p>error something</p>
            return (
              <TagFilter
                data={tmpFilterBy}
                onChange={handleOnChangeFilter}
                onClear={handleOnClearFilter}
              />
            )
          }
        }
        </Query>
      </Modal>
      <Modal
        title={
          <Label color={theme.color.textColor} style={{ fontWeight: theme.fonts.style.regular }}>
            <Icon icon='fas fa-sort-amount-down' margin='0px 14px 0px 0px' color={theme.color.primaryColor} style={{ fontWeight: theme.fonts.style.regular }} />
            ตัวเลือก
          </Label>
        }
        visible={settingVisible}
        onCancel={handleCloseSort}
        footer={null}
        closable={false}
        centered={true}
      >
        <Div position='absolute' top='16px' right='16px' cursor='pointer' onClick={handleCloseSort}>
          <Icon fontSize={theme.fonts.size.extraNormal} color={theme.color.grey} icon='far fa-times' />
        </Div>
        <CustomSelect
          dropdown
          suffixIcon={
            <Icon fontSize={theme.fonts.size.extraNormal} icon='far fa-angle-down' />
          }
          optionFilterProp="children"
          value={tmpSortBy.order !== 'ordering' ? `${tmpSortBy.order}_${tmpSortBy.sort}` : 'กรุณาเลือกวิธีจัดเรียง'}
          onChange={handleSort}
        >
          <Select.Option key={'createdAtDESC'} value={'createdAt_DESC'}>{'ตามวันเวลา (ใหม่ -> เก่า)'}</Select.Option>
          <Select.Option key={'createdAtASC'} value={'createdAt_ASC'}>{'ตามวันเวลา (เก่า -> ใหม่)'}</Select.Option>
          <Select.Option key={'nameASC'} value={'name_ASC'}>{'ตามชื่อ (A(ก) -> Z(ฮ))'}</Select.Option>
          <Select.Option key={'nameDESC'} value={'name_DESC'}>{'ตามชื่อ (Z(ฮ) -> A(ก))'}</Select.Option>
        </CustomSelect>
      </Modal>
    </Container>
  )
}

const Search = ({
  value,
  onSummit,
}) => {
  const [textSearch, setTextSearch] = useState(value)

  const onSummitSearch = (e) => {
    e.preventDefault()
    onSummit(textSearch)
  }

  return (
    <form
      style={{ width: '100%' }}
      onSubmit={onSummitSearch}
    >
      <DivSearch>
        <ButtonSearch
          htmlType="submit"
          text='ค้นหา'
          icon='far fa-search'
          inverse
        />
        <InputSearch
          value={textSearch}
          onChange={ e => setTextSearch(e.target.value)}
        />
      </DivSearch>
    </form>
  )
}

const Image = ({ img }) => (
  <ImageWrapper>
    <ImgBg img={img} />
  </ImageWrapper>
)

const Package = ({
  data,
  onClick,
}) => {
  const file = data.packageFiles.filter(item => item.type === 'cover')
  const {
    name,
    ordering,
  } = data
  return (
    <DivPackage onClick={onClick}>
      <PackageContent ordering={ordering} file={file} name={name} />
    </DivPackage>
  )
}

export const PackageContent = ({ ordering, file, name }) => (
  <Div>
    <Image
      img={ file.length > 0 ? file[0].packageFileUri : ''}
    />
    {ordering === -1 ? (
      <ImageLabelOther>{name || 'Unknown'}</ImageLabelOther>
    ) : (
      <ImageLabel>{name || 'Unknown'}</ImageLabel>
    )}
  </Div>
)

export default PackagingCatalogContainer



// WEBPACK FOOTER //
// ./src/pages/package-page/list/index.jsx